import { useRequest } from 'domain/core/hooks/useRequest';
import { TUpdate } from 'domain/types';
import {
  GlobalConfigContext,
  TGlobalConfigContextState,
} from 'domain/globalConfig/GlobalConfigContext';
import { useContextSelector as useCS } from 'use-context-selector';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';
import { useEffect } from 'react';
import { storageService } from 'infrastructure/services/StorageService';
import { RolesEnum } from 'infrastructure/enums/RolesEnum';
import { useNavigate } from 'react-router';

export const useAuthMe = (sendOnStart: boolean) => {
  const navigate = useNavigate();
  const globalUpdate: TUpdate<TGlobalConfigContextState> | undefined = useCS(
    GlobalConfigContext,
    globalConfigSelectors.update
  );

  const { data, isLoading, send } = useRequest({
    url: '/api/v1/auth/me',
    sendOnStart,
  });

  useEffect(() => {
    if (isLoading || !data) return;
    if (data?.role?.id === 1) {
      storageService.removeItem('accessToken');
      storageService.removeItem('refreshToken');
      navigate('/auth/onboarding', { replace: true });
      return;
    }
    if (data?.role?.name === RolesEnum.GUEST) {
      navigate('/auth/choose-your-role', { replace: true });
    }
    globalUpdate?.({ userData: data, isReady: true });
  }, [data, isLoading, globalUpdate]);

  return { send };
};
